<template>
	<layoutSection class="relative overflow-hidden rounded-GO tablet:rounded-tr-none bg-goPinkBrighter">
		<div class="relative z-10 p-16 tablet:p-48 desktop:p-56 desktopWide:px-0 tabletWide:w-10/12 desktop:w-full">
			<layoutPost type="wide">
				<h2 class="font-bold text-20 tablet:text-24">{{ title }}</h2>
				<ul class="space-y-16 text-16">
					<li v-for="(item, index) in list" :key="index" class="bg-iconChevron pl-32">
						<strong class="font-bold">{{ item.title }}:</strong> <span v-html="item.text"></span>
					</li>
				</ul>
			</layoutPost>
		</div>
	</layoutSection>
</template>

<script>
import layoutSection from "~/components/layoutSection.vue"
import layoutPost from "~/components/layoutPost.vue"

export default {
	components: {
		layoutSection,
		layoutPost,
	},
	props: {
		title: {
			type: String,
			default: "GO Rentals Customer Quick Facts",
		},
		minAgeItemText: {
			type: String,
			default: "You must be 21 years old to cruise in a standard GO Rentals hire car and 25 to experience the Tesla Model 3 and Tesla Model Y hire cars. Good news: we do not apply a young driver surcharge!"
		}
	},
	data() {
		return {
			list: [
				{
					title: "Minimum Age",
					text: this.minAgeItemText
				},
				{
					title: "Maximum Age",
					text: "There is no age limit to GO with us! As long as you have a valid licence, we welcome you with open arms."
				},
				{
					title: "New Zealand Licence Rule",
					text: "Temporary, restricted and full driver's licences are permitted to rent some vehicles with GO. <strong>Photo identification is required</strong> if hiring a vehicle with a New Zealand temporary licence. Electric vehicles cannot be hired on a restricted licence."
				},
				{
					title: "Foreign Licence Rule",
					text: "Valid, full driver's licences are accepted from overseas travellers but must be translated to English and NZTA approved. Foreign learner's and provisional licences are not valid for renting with GO."
				},
				{
					title: "Credit Card Requirement",
					text: "A credit card is required for bookings with the Basic or Assured insurance options that require a bond deposit. A debit card is acceptable for the upgraded Peace of Mind or some Assured insurance options without a bond requirement."
				},
				{
					title: "Additional Drivers",
					text: "Simply pop in to any of our branches and show us your driver's licence to add you onto a booking."
				},
				{
					title: "Family needs",
					text: "You can hire baby capsules, child seats and booster seats for your little ones! Add them onto your booking quote and we will fit them ready for you to GO."
				},
				{
					title: "Documents for collection",
					text: "You will need your valid driver licence and your debit or credit card in your name. Note that a credit card is required for bookings with the Basic or Assured insurance option that requires a bond deposit."
				},
			],
		}
	}
}
</script>
